import PropTypes from "prop-types";
import React from "react";
import CandlestickChart from "./CandlestickChart";

const TREND_COLORS = {
  bullish: "#FF1F56",
  bearish: "#4280BE",
  neutral: "#9CA3AF",
};

const getTrendColor = ({ trend }) =>
  TREND_COLORS[trend] || TREND_COLORS.neutral;

const HEART_RATE_CONFIG = {
  height: 320,
  bodyWidth: 8,
  yAxisMin: 0,
  yAxisMax: 200,
  grid: { left: 20, right: 12, top: 16, bottom: 32 },
  unit: " bpm",
  getColor: getTrendColor,
};

function HeartRateChart({ heartRateDevices }) {
  return (
    <CandlestickChart data={heartRateDevices} config={HEART_RATE_CONFIG} />
  );
}

HeartRateChart.propTypes = {
  heartRateDevices: PropTypes.shape({
    range: PropTypes.string,
    data_points: PropTypes.arrayOf(
      PropTypes.shape({
        timestamp: PropTypes.string,
        open: PropTypes.number,
        close: PropTypes.number,
        high: PropTypes.number,
        low: PropTypes.number,
        trend: PropTypes.string,
        type: PropTypes.string,
      })
    ),
  }),
};

HeartRateChart.defaultProps = {
  heartRateDevices: {
    range: "hour",
    data_points: [],
  },
};

export default HeartRateChart;
